import {css} from "@emotion/css";
import {useEffect, useState} from "react";
import React from 'react';
import {Box, Grid, Typography} from "@mui/material";
import ErrorPage, {ErrorType} from "../ErrorPage/ErrorPage";
import "./FileManagerStyleSheet.css"
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {convertCurrencyFormatPositiveNegative} from "../../util/numberConvertor";
import RaikoDefaultDialogPage, {DialogSize} from "../defaultDialogPage/RaikoDefaultDialogPage";
import {Alert, AlertTitle} from "@mui/lab";
import {FileManagerService} from "./FileManagerService";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {useAuthState} from "../../context/AuthContext";
import ButtonSecondaryRaiko from "../../raikoComponents/raikoButtons/ButtonSecondaryRaiko";
import FileManagerUploadNewImage from "./FileManagerUploadNewImage";
import {useRef} from "react";
import useDraggableScroll from "use-draggable-scroll";
import {Helmet} from "react-helmet";
import {RouteInfo} from "../../route/RouteHelper";
import Pagination from "@mui/material/Pagination";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import PropTypes from "prop-types";
import {LoadingHelper} from "../../util/LoadingHelper";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {prepareRaikoSelectBoxItem, RaikoSelectBox} from "../../raikoComponents/raikoSelectBox/RaikoSelectBox";
import {RaikoCustomTooltip} from "../../raikoComponents/raikoTooltip/RaikoCustomTooltip";
import RaikoBreadcrumb, {
    raikoBreadCrumbItemGenerator
} from "../../raikoComponents/raikoBreadcrumbCustom/RaikoBreadcrumb";

let selectedFileForDelete = -1
const FileManager = (
    {
        isDialog = false,
        defaultGalleryType = FileManagerTypes.POST_THUMBNAILS,
        setSelectedFileUrl,
        setOpenDialog
    }) => {

    let page = 0;

    const loadingDispatcher = useLoadingDispatcher()
    const snackbarDispatcher = useSnackbarDispatcher()
    const token = useAuthState().token

    const loading = new LoadingHelper(loadingDispatcher)
    const snackbar = new SnackbarHelper(snackbarDispatcher)

    const service = new FileManagerService(loadingDispatcher, snackbarDispatcher, token)

    const [selectedFileMangerType, setSelectedFileMangerType] = useState(defaultGalleryType);
    const [itemCount, setItemCount] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [filesList, setFilesList] = useState([]);

    const [openHandleEndDialog, setOpenHandleEndDialog] = useState(false);

    const handleClickOpenEndElectionDialog = () => {
        setOpenHandleEndDialog(true);
    };

    const handleCloseChangeEndElectionDialog = () => {
        selectedFileForDelete = -1
        setOpenHandleEndDialog(false);
    };

    const [needRefresh, setNeedRefresh] = useState(false);

    function doDeleteImage() {
        service.deleteFile(FileManagerTypes, selectedFileForDelete)
            .then(_ => {
                snackbarDispatcher(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "تصویر انتخاب شده با موفقیت حذف شد."))
                loadingDispatcher(setLoadingStateDispatch(false))

                getListDataFromServer()
                handleCloseChangeEndElectionDialog()
            }).catch(_ => {
            snackbarDispatcher(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در حذف تصویر انتخاب شده!"))
            loadingDispatcher(setLoadingStateDispatch(false))
        })
    }

    function getListDataFromServer() {
        loadingDispatcher(setLoadingStateDispatch(true))
        service.getImages(selectedFileMangerType, page)
            .then(response => {
                loadingDispatcher(setLoadingStateDispatch(false))
                setFilesData(response)
            }).catch(_ => {
            loadingDispatcher(setLoadingStateDispatch(false))
        })
    }

    function setFilesData(filesData) {
        setItemCount(filesData.numberOfItems)
        setPageCount(filesData.totalPage)
        setFilesList([])
        filesData.data.map(async (item, _) => {
            setFilesList(prevState => [
                ...prevState, {
                    url: item.url,
                    loadedImage: item.url,
                    realName: item.metadata.realName,
                    size: item.metadata.size,
                    uploadedAt: item.metadata.uploadedAt,
                    id: item.metadata.id,
                }
            ])
        })
    }

    const [openModal, setOpenModal] = useState(false)

    function handleCloseUploadModal() {
        setOpenModal(false)
        if (needRefresh) {
            setNeedRefresh(false)
            getListDataFromServer()
        }
    }

    function handleOpenUploadModal() {
        setOpenModal(true)
    }

    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'horizontal'});


    useEffect(() => {
        if (typeof selectedFileMangerType !== 'undefined') {
            page = 0
            getListDataFromServer()
        }
    }, [selectedFileMangerType])

    function doSelectGalleryFile(id) {
        if (isDialog) {
            loading.show()
            service.getImageUrl(id)
                .then(response => {
                    setSelectedFileUrl(id, response.url)
                    setOpenDialog(false)
                    loading.hide()
                }).catch(reason => {
                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت لینک تصویر از سرور!"))
                loading.hide()
            })


        }
    }

    function handleChangePagination(event, value) {
        page = value - 1
        getListDataFromServer()
    }

    return (
        <>
            <Helmet>
                <title>{RouteInfo.Files.name}</title>
            </Helmet>
            <FileManagerUploadNewImage
                needRefresh={setNeedRefresh}
                handleClose={handleCloseUploadModal}
                openModal={openModal}
                fileManagerType={selectedFileMangerType}
            />

            <RaikoDefaultDialogPage
                onClose={handleCloseChangeEndElectionDialog}
                open={openHandleEndDialog}
                selectedValue={""}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={"حذف تصویر"}
            >
                <section className={css`display: flex;
                  flex-direction: column;
                  padding: 0 16px 16px 16px;
                  overflow-x: hidden !important;
                `}>

                    <div className="deleteDialogContainer">

                        <Alert severity="warning">
                            <AlertTitle> آیا از حذف تصویر اطمینان دارید ؟!</AlertTitle>
                            <div className={css`display: flex;
                              flex-direction: column;
                              gap: 8px;
                              margin-top: 16px;
                            `}>
                                با حذف تصویر امکان بازیابی آن وجود نخواهد داشت !!!
                            </div>
                        </Alert>

                    </div>

                    <div className="d-flex flex-column w-100">

                        <div className="deleteDialogButtonContainer">
                            <ButtonSecondaryRaiko onClick={doDeleteImage} label={" حذف کن"}/>
                            <ButtonPrimaryRaiko onClick={handleCloseChangeEndElectionDialog} label={"بیخیال"}/>
                        </div>
                    </div>
                </section>
            </RaikoDefaultDialogPage>

            <section className={css`
              padding: 26px;
              overflow: hidden !important;
              max-width: 100vw;
              flex-grow: 1;
              transition: var(--base-transition);
              background: var(--color-surface);
            `}>
                {!isDialog &&
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator("فایل ها", ""),
                        raikoBreadCrumbItemGenerator(selectedFileMangerType.name, ""),
                    ]}/>
                }

                <section
                    className={`${css`
                      display: flex;
                      flex-direction: column;
                    `}`}>
                    {!isDialog &&
                        <span className={css`
                          color: var(--color-text);
                          font-size: var(--text-size-default);
                          margin-top: 40px;
                        `}>
                    دسته ها
                    </span>}

                    {
                        !isDialog &&
                        <section className="galleryTypeItemsContainer hideScroll" ref={ref} onMouseDown={onMouseDown}>
                            <RaikoSelectBox
                                changeSelectItem={id => {
                                    for (let i = 0; i < fileManagerFolderList.length; i++) {
                                        let element = fileManagerFolderList[i];
                                        if (element.id === id) {
                                            setSelectedFileMangerType(element)
                                            break;
                                        }
                                    }
                                }}
                                items={fileManagerFolderList2}
                                defaultSelectedItem={selectedFileMangerType.id}

                            />

                        </section>
                    }
                    <section className="galleryPictureListDetails">
                        <section className={css`
                          display: flex;
                          flex-direction: column;
                          align-items: start;
                        `}>
                            <Typography className="headerTitle">
                                لیست تصاویر
                            </Typography>
                            {itemCount > 0 ?
                                <Typography className={css`color: var(--color-text);
                                  font-size: var(--text-size-min) !important;
                                  margin-top: .5rem !important;`}>
                                    {" " + itemCount + " تصویر بارگذاری شده"}
                                </Typography> :
                                ''}
                        </section>
                        <ButtonPrimaryRaiko
                            label={"آپلود"}
                            className={css`
                              height: fit-content !important;
                            `}
                            onClick={handleOpenUploadModal}
                        />
                    </section>
                    <Box className="galleryItemList">
                        {filesList && filesList.length > 0 ?
                            filesList.map((file, index) => {
                                return <Grid key={index} xs={12} lg={12} md={12} sm={12}
                                             onClick={_ => doSelectGalleryFile(file.id)}
                                             className="galleryItemDetails default-card-container-background-style">
                                    <Grid xs={12} lg={9} md={9} sm={9} xl={9} className="galleryItemContent">
                                        <Grid xs={12} lg={9} md={9} sm={9} xl={9}>
                                            <img className="thumbnailImage default-card-container-background-style"
                                                 src={file.loadedImage}
                                                 alt="thumbnail"/>
                                        </Grid>
                                        <Grid xs={6} sm={4} md={3} lg={2} xl={2} className="galleryItemTitleWrapper">
                                            <span className="galleryItemDescription">{file.realName}</span>
                                        </Grid>
                                    </Grid>
                                    <Grid className="date-and-volume">
                                        <Grid xs={3} sm={4} md={3} lg={2} xl={2} className="galleryItemWrapper">
                                            <span
                                                className="videoSize">{convertCurrencyFormatPositiveNegative(Math.ceil(file.size / 1024))} کیلوبایت</span>
                                        </Grid>
                                        <div className="galleryItemWrapper">
                                                     <span className="galleryItemDescription">
                                                      <div className={`ic-time`}/>
                                                         {file.uploadedAt ? convertUniversalDateToPersianDate(file.uploadedAt) : "-"}
                                                      </span>
                                        </div>
                                    </Grid>
                                    <Grid xs={12} lg={3} md={3} sm={3} xl={3} className="buttonGroup">
                                        <div className="lineVisible ic-line"/>

                                        <a href={file.url} download={true}
                                           target={"_blank"} rel={"noreferrer"}>
                                            <RaikoCustomTooltip title="دانلود">
                                                <button className="btnAccess download-icon"/>
                                            </RaikoCustomTooltip>
                                        </a>
                                        <RaikoCustomTooltip title="کپی لینک">
                                            <button
                                                onClick={_ => {
                                                    navigator.clipboard.writeText(file.url)
                                                        .then(_ => {
                                                            snackbarDispatcher(setSnackbarDispatch(SnackbarActionTypes.SHOW_INFO, "لینک تصویر با موفقیت کپی شد."))
                                                        }).catch(_ => {
                                                        snackbarDispatcher(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در کپی کردن لینک تصویر!"))

                                                    })
                                                }}
                                                className="btnAccess share-link-icon"/>
                                        </RaikoCustomTooltip>
                                        <RaikoCustomTooltip title="حذف">
                                            <button onClick={_ => {
                                                selectedFileForDelete = file.id
                                                handleClickOpenEndElectionDialog(true)
                                            }} className="btnAccess delete-icon"/>
                                        </RaikoCustomTooltip>
                                    </Grid>
                                </Grid>
                            }) :
                            <ErrorPage errorType={ErrorType.NOT_FOUND} subTitle={""}/>
                        }
                        <div
                            className={css`
                              width: 100%;
                              display: flex;
                              justify-content: center;
                              align-content: center;
                              margin-top: 16px;
                            `}>
                            <Pagination
                                count={pageCount}
                                shape="rounded"
                                onChange={handleChangePagination}
                                className={pageCount && pageCount > 0 ? "" : css`display: none`}
                            />
                        </div>
                    </Box>

                </section>
            </section>
        </>
    )
}
export default FileManager;

FileManager.propTypes = {
    isDialog: PropTypes.bool,
}

export const FileManagerTypes = {
    "POST_THUMBNAILS": {
        id: "POST_THUMBNAILS",
        name: "اخبار",
        uploadUrl: "buckets/POST_THUMBNAILS/files"
    },
    "SLIDER_ITEM_THUMBNAIL": {
        id: "SLIDER_ITEM_THUMBNAILS",
        name: "اسلایدر",
        uploadUrl: "buckets/SLIDER_ITEM_THUMBNAIL/files"
    },
    "MULTI_MEDIA_THUMBNAIL": {
        id: "MULTI_MEDIA_THUMBNAILS",
        name: "چندرسانه ای",
        uploadUrl: "buckets/MULTI_MEDIA_THUMBNAIL/files"
    },
    "ADMINS_AVATARS": {
        id: "ADMINS_AVATARS",
        name: "آواتار ادمین",
        uploadUrl: "buckets/ADMINS_AVATARS/files"
    },
    "MARTYRS_AVATARS": {
        id: "MARTYRS_AVATARS",
        name: "آواتار شهدا",
        uploadUrl: "buckets/MARTYRS_AVATARS/files"
    },
}

const fileManagerFolderList = [
    FileManagerTypes.MULTI_MEDIA_THUMBNAIL,
    FileManagerTypes.SLIDER_ITEM_THUMBNAIL,
    FileManagerTypes.POST_THUMBNAILS,
    FileManagerTypes.MARTYRS_AVATARS,
    FileManagerTypes.ADMINS_AVATARS,
]

const fileManagerFolderList2 = [
    prepareRaikoSelectBoxItem(FileManagerTypes.POST_THUMBNAILS.id, FileManagerTypes.POST_THUMBNAILS.name),
    prepareRaikoSelectBoxItem(FileManagerTypes.SLIDER_ITEM_THUMBNAIL.id, FileManagerTypes.SLIDER_ITEM_THUMBNAIL.name),
    prepareRaikoSelectBoxItem(FileManagerTypes.MULTI_MEDIA_THUMBNAIL.id, FileManagerTypes.MULTI_MEDIA_THUMBNAIL.name),
]
